<template>
	<div class="app">
		<Transition>
			<div
				v-if="pageLoaded && currentLanguage"
				id="page"
				class="app__wrapper"
			>
				<Header
					:currency-code="currencyCode"
					:currency-options="currencyOptions"
					:currency-code-id="currencyCodeId"
					:cart-contents="cartContents"
					:is-auth="isAuth"
					:is-scrolable="isScrolable"
					:menu-visible="menuVisible"
					@changeCurrency="changeCurrency"
					@openSignIn="openSignIn"
					@openSignUp="openSignUp"
					@removeOneFromCart="removeOneFromCart"
					@openSellSkinModal="openSellSkinModal"
					@closeMenu="closeMenu"
					@toggleMenu="toggleMenu"
					@openLoginModal="openLoginModal"
					@openSignupModal="openSignupModal"
					@openCartModal="openCartModal"
				/>
				<div class="app__content">
					<!--<div class="app__content-bg _ibg">
						<img src="@/assets/img/bg/page-bg.png" />
					</div>-->
					<router-view
						:minTopupAmount="minTopupAmount"
						:currency-code="currencyCode"
						:lang="currentLanguage"
						:currency-symbol="currencySymbol"
						:text-page-title="textPageTitle"
						:text-page-header="textPageHeader"
						:text-page-content="textPageContent"
						:is-auth="isAuth"
						:order-history="orderHistory"
						:total-sum="totalSum"
						:error="error"
						:cart-contents="cartContents"
						:hostname="hostname"
						:footer-support-email="footerSupportEmail"
						:chosen-item="chosenItem"
						:successMessage="successMessage"
						:loader-is-visible="loaderIsVisible"
						:showResendOption="showResendOption"
						:offer-history="offerHistory"
						:preview-skin-modal-is-visible="previewSkinModalIsVisible"
						@formatDate="formatDate"
						@goToProduct="goToProduct"
						@openSignUp="openSignUp"
						@openSellSkinModal="openSellSkinModal"
						@openPreviewSkinModal="openPreviewSkinModal"
						@closePreviewSkinModal="closePreviewSkinModal"
						@logout="logout"
						@addToCart="addToCart"
						@removeOneFromCart="removeOneFromCart"
						@removeFromCart="removeFromCart"
						@openOrderModal="openOrderModal"
						@openWithdraw="openWithdraw"
						@login="login"
						@forgotPass="forgotPass"
						@clearError="clearError"
						@hideResendOption="hideResendOption"
						@resendVerificationEmail="resendVerificationEmail"
						@registration="registration"
						@openProductModal="openProductModal"
						@openCartModal="openCartModal"
						@openLoginModal="openLoginModal"
					/>
				</div>
				<Footer
					:isAuth="isAuth"
					:text-page-list="textPageList"
					:footer-requisites="footerRequisites"
					:footer-support-email="footerSupportEmail"
					:footerCopyright="footerCopyright"
					:paymentMethods="allPaymentMethods"
					@openSignIn="openSignIn"
					@openSellSkinModal="openSellSkinModal"
				/>

				<LoginModal
					v-if="isLoginModalVisibale"
					:error="error"
					:loader-is-visible="loaderIsVisible"
					:showResendOption="showResendOption"
					:success-message="successMessage"
					@close="closeLoginModal"
					@login="login"
					@forgotPass="forgotPass"
					@registration="registration"
				/>

				<SignupModal
					v-if="isSignupModalVisibale && !isAuth"
					:error="error"
					:loader-is-visible="loaderIsVisible"
					:showResendOption="showResendOption"
					@close="closeSignupModal"
					@registration="registration"
				/>

				<ProductModal
					v-if="isProductModalVisibale"
					:isAuth="isAuth"
					:id="productModalItemId"
					:chosen-item="chosenItem"
					@close="closeProductModal"
					@openLoginModal="openLoginModal"
					@addToCart="addToCart"
				/>
				<CartModal
					v-if="isCartModalVisible && isAuth"
					:is-auth="isAuth"
					:cart-contents="cartContents"
					@close="closeCartModal"
				/>

				<!--<Transition>
					<SellSkinModal
						v-if="sellSkinModalIsVisible"
						:currency-symbol="currencySymbol"
						@setError="setError"
						@openOrderModal="openOrderModal"
						@offerCreated="onOfferCreated"
						:error="error"
						@closeSellSkinModal="closeSellSkinModal"
					/>
				</Transition>-->
				<!--<Transition>
					<PayoutModal
						v-if="withdrawModalIsVisible"
						:currencyCode="currencyCode"
						:currency-symbol="currencySymbol"
						@closeWithdraw="closeWithdraw"
						@openSignIn="openSignIn"
					/>
				</Transition>-->

				<CookiesModal />
			</div>
		</Transition>
	</div>
</template>

<script>
import {
	COOKIE_PAGE,
	PRIVACY_PAGE,
	TERMS_PAGE,
} from '@/store/modules/staticPages';
import { loadScriptsFromString } from '@/utils/load_scripts';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import CookiesModal from './components/CookiesModal.vue';
import Footer from './components/FooterComponent.vue';
import Header from './components/HeaderComponent.vue';
//import PayoutModal from './components/PayoutModal.vue';
import CartModal from './components/Modals/CartModal.vue';
import LoginModal from './components/Modals/LoginModal.vue';
import ProductModal from './components/Modals/ProductModal.vue';
import SignupModal from './components/Modals/SignupModal.vue';

export default {
	name: 'App',
	components: {
		//PayoutModal,
		Header,
		Footer,
		CookiesModal,
		LoginModal,
		SignupModal,
		ProductModal,
		CartModal,
	},
	data: function () {
		return {
			isAuth: false,
			showResendOption: false,
			currencyCodeId: '',
			currencyOptions: [],
			pageLoaded: false,
			error: '',
			productModalIsVisible: false,
			productPageItem: {},
			textPageList: [],
			textPageTitle: '',
			textPageHeader: '',
			textPageContent: '',
			menuVisible: false,
			successMessage: '',
			totalSum: '',
			chosenItem: '',
			loaderIsVisible: false,
			orderHistory: [],
			offerHistory: [],
			orderModalIsVisible: false,
			orderData: {},
			allPaymentMethods: [],
			availablePaymentMethods: [],
			minTopupAmount: 0,
			hostname: '',
			cookesModalIsVisible: false,
			isLoginModalVisibale: false,
			isSignupModalVisibale: false,
			isProductModalVisibale: false,
			isCartModalVisible: false,
			productModalItemId: null,
			footerCopyright: '',
			withdrawModalIsVisible: true,
			sellSkinModalIsVisible: false,
			previewSkinModalIsVisible: false,
			appBalanceUpdated: false,
			lastUserBalance: null,
			hasInitialBalance: false,
			depositCheckPending: false,
		};
	},
	computed: {
		...mapState('app', ['currentLanguage']),
		...mapGetters('app', ['currencyCode', 'currencySymbol']),
		...mapGetters('cart', ['cartContents']),
		...mapGetters('staticPages', ['getPageByType']),
		...mapGetters('modals', [
			'depositModalIsVisible',
			'cartDropdownIsVisible',
		]),
		...mapGetters('user', ['userBalance']),
	},
	watch: {
		currentLanguage() {
			this.getTextPages();
		},
		currencyCode() {
			if (this.productPageItem && this.productPageItem.length) {
				this.getProductPageContent(this.productPageItem);
			}
			if (this.isAuth) {
				this.orderHistory = '';
				this.offerHistory = '';
				this.cartContents = '';
				this.totalSum = '';
				this.getOrderHistory();
				this.getOfferHistory();
				this.fetchCartItems();
				this.fetchUserData();
			}
		},
		userBalance(newVal) {
			this.handleUserBalanceChange(newVal);
		},
		async $route() {
			this.error = '';
			window.scrollTo(0, 0);
			this.closeMenu();
			//this.closeCartDropdown();
			if (this.isAuth) {
				this.getOrderHistory();
				this.getOfferHistory();
			}

			const path = this.$route?.path || window.location.pathname;
			if (path && path.startsWith('/success-payment')) {
				this.checkSuccessPaymentOnLoad();

				try {
					await this.fetchUserData();
					this.startPostDepositPolling();
				} catch (e) {
					console.log(
						'Failed to refresh user data after success payment',
						e
					);
				}
			}

			this.$nextTick(() => {
				this.checkHeight();
			});
		},
	},
	methods: {
		checkSuccessPaymentOnLoad() {
			const path = this.$route?.path || window.location.pathname;
			if (path && path.startsWith('/success-payment')) {
				const stored = localStorage.getItem('preDepositBalance');
				const started = localStorage.getItem('depositJustStarted');

				if (stored !== null && started === '1') {
					const baseline = Number(stored);
					if (!Number.isNaN(baseline)) {
						this.lastUserBalance = baseline;
						this.hasInitialBalance = true;
						this.depositCheckPending = true;
					}
				}
			}
		},
		async startPostDepositPolling() {
			if (!this.depositCheckPending) return;

			let attempts = 3;
			const delayMs = 1000;

			const sleep = (ms) => new Promise((res) => setTimeout(res, ms));

			for (let i = 0; i < attempts; i++) {
				try {
					await this.fetchUserData();
				} catch (e) {
					console.error('Post-deposit polling fetchUserData failed', e);
				}

				if (!this.depositCheckPending) {
					console.log('[App] deposit detected, stop polling');
					return;
				}

				await sleep(delayMs);
			}

			console.log('[App] deposit polling finished without change');
		},

		handleUserBalanceChange(newVal) {
			if (newVal === '' || newVal === null || newVal === undefined) {
				return;
			}

			const current = Number(newVal);
			if (Number.isNaN(current)) return;

			// if we never had an initial baseline yet, try from localStorage
			if (!this.hasInitialBalance) {
				const stored = localStorage.getItem('preDepositBalance');
				const started = localStorage.getItem('depositJustStarted');
				if (stored !== null && started === '1') {
					const baseline = Number(stored);
					if (!Number.isNaN(baseline)) {
						this.lastUserBalance = baseline;
						this.hasInitialBalance = true;
						this.depositCheckPending = true;
					}
				}
			}

			if (!this.hasInitialBalance) {
				this.hasInitialBalance = true;
				this.lastUserBalance = current;
				return;
			}

			const prev = this.lastUserBalance;

			if (
				typeof prev === 'number' &&
				!Number.isNaN(prev) &&
				current > prev
			) {
				this.depositCheckPending = false;
				localStorage.removeItem('preDepositBalance');
				localStorage.removeItem('depositJustStarted');
			}

			this.lastUserBalance = current;
		},

		onOfferCreated() {
			this.getOfferHistory();
		},
		getScrollbarWidth() {
			return window.innerWidth - document.documentElement.clientWidth;
		},
		checkHeight() {
			const body = document.body;
			const html = document.documentElement;

			const pageHeight = Math.max(
				body.scrollHeight,
				body.offsetHeight,
				html.clientHeight,
				html.scrollHeight,
				html.offsetHeight
			);
			const viewportHeight = window.innerHeight || html.clientHeight;

			if (pageHeight > viewportHeight) {
				body.classList.add('isScrolabal');
			} else {
				body.classList.remove('isScrolabal');
			}
		},
		clearError() {
			this.error = '';
		},
		setError(error) {
			this.error = error;
		},
		lockScroll() {
			const scrollBarWidth =
				window.innerWidth - document.documentElement.clientWidth;

			document.body.style.overflow = 'hidden';
			document.body.style.paddingRight = scrollBarWidth + 'px';
		},

		unlockScroll() {
			document.body.style.overflow = '';
			document.body.style.paddingRight = '';
		},
		openLoginModal() {
			this.isLoginModalVisibale = true;
			this.lockScroll();
		},
		closeLoginModal() {
			this.isLoginModalVisibale = false;
			this.error = '';
			this.unlockScroll();
		},
		openSignupModal() {
			this.isSignupModalVisibale = true;
			this.lockScroll();
		},
		closeSignupModal() {
			this.isSignupModalVisibale = false;
			this.error = '';
			this.unlockScroll();
		},
		openProductModal(id) {
			this.isProductModalVisibale = true;
			this.productModalItemId = id;
			this.lockScroll();
		},
		closeProductModal() {
			this.isProductModalVisibale = false;
			this.productModalItemId = null;
			this.unlockScroll();
		},
		openCartModal() {
			if (!this.isAuth) {
				this.openLoginModal();
				return;
			}
			this.isCartModalVisible = true;
			this.lockScroll();
		},
		closeCartModal() {
			this.isCartModalVisible = false;
			this.unlockScroll();
		},
		openPreviewSkinModal() {
			this.previewSkinModalIsVisible = true;
			this.lockScroll();
		},
		closePreviewSkinModal() {
			this.previewSkinModalIsVisible = false;
			this.error = '';
			this.unlockScroll();
		},
		openSellSkinModal() {
			this.sellSkinModalIsVisible = true;
			this.lockScroll();
		},
		closeSellSkinModal() {
			this.sellSkinModalIsVisible = false;
			this.error = '';
			this.unlockScroll();
		},
		closeWithdraw() {
			this.withdrawModalIsVisible = false;
			this.unlockScroll();
		},
		openWithdraw() {
			this.withdrawModalIsVisible = true;
			this.lockScroll();
		},
		...mapActions('app', ['fetchCurrencies', 'changeCurrency']),
		...mapActions('modals', ['closeDepositModal']),
		...mapActions('user', ['fetchUserData']),
		...mapActions('cart', ['fetchCartItems', 'clearCart']),
		...mapMutations('cart', {
			updateCartContents: 'UPDATE_CART_CONTENTS',
		}),
		...mapActions('staticPages', ['fetchPages', 'fetchPageContent']),
		async fetchPaymentMethods(countryId, currencyCode) {
			this.$http
				.post(process.env.VUE_APP_API + 'orders/payment-methods', {
					country: countryId,
					currency: currencyCode,
				})
				.then((response) => {
					if (response.data.status === 'OK') {
						this.availablePaymentMethods = response.data.payload;
					} else {
						this.error = this.$t(response.data.message);
					}
				})
				.catch((error) => {
					console.error('Error fetching payment methods:', error);
					this.error = this.$t('Error fetching payment methods');
				});
		},
		resendVerificationEmail(data) {
			this.error = '';
			this.$http
				.post(process.env.VUE_APP_API + 'resendConfirmationLink', {
					email: data,
				})
				.then((res) => {
					if (res.data.status == 'OK') {
						this.error = '';
						this.successMessage = this.$t(
							'Confirmation link has been resent.'
						);
					} else {
						this.error = this.$t(res.data.message);
						this.successMessage = '';
					}
				})
				.catch((res) => {
					this.error = this.$t(res.response.data.message);
				});
		},
		getDomainName(hostName) {
			return hostName.substring(
				hostName.lastIndexOf('.', hostName.lastIndexOf('.') - 1) + 1
			);
		},
		orderSubmit(data, type) {
			data.paymentType = type;
			data.currency = this.currencyCode;
			this.$http
				.post(process.env.VUE_APP_API + 'orders/checkout', data)
				.then((res) => {
					if (res.data.status == 'ERROR') {
						this.$router.push({ name: 'PaymentFailPage' });
						this.closeOrderModal();
					} else {
						window.location = res.data.redirect_url;
					}
				})
				.catch((res) => {
					this.$toast.error(this.$t(res.response.data.message), {
						multiple: false,
					});
					this.error = this.$t(res.response.data.message);
				});
		},
		getOrderHistory() {
			this.$http
				.get(process.env.VUE_APP_API + 'purchase/history')
				.then((res) => {
					this.orderHistory = res.data.payload;
				})
				.catch((res) => {
					if (res.response.status === 401) {
						this.openLoginModal();
					}
				});
		},
		getOfferHistory() {
			this.$http
				.get(process.env.VUE_APP_API + 'offer/history')
				.then((res) => {
					this.offerHistory = res.data.payload;
				})
				.catch((err) => {
					if (err.response && err.response.status === 401) {
						this.openLoginModal();
					}
				});
		},
		addToCart(item) {
			if (!this.isAuth) {
				//this.$router.push('/signin');
				this.openLoginModal();
			} else {
				let self = this;

				let cartItem = {
					id: item.id,
					count: 1,
				};

				for (var i = 0; i < this.cartContents.length; i++) {
					if (this.cartContents[i].item_id == item.id) {
						let cartItemCount = this.cartContents[i].count;
						cartItem = {
							...cartItem,
							count: cartItemCount + 1,
						};
						break;
					}
				}
				this.loaderIsVisible = true;
				this.$http
					.post(process.env.VUE_APP_API + 'cart/add', cartItem)
					.then((res) => {
						self.loaderIsVisible = false;
						self.fetchCartItems();
						self.chosenItem = cartItem.id;
						self.updateCartContents(res.data.cart);
						setTimeout(() => {
							self.chosenItem = '';
						}, 2000);
					})
					.catch((res) => {
						self.loaderIsVisible = false;
						if (res.response.status === 401) {
							this.openLoginModal();
						} else {
							self.error = this.$t(res.response.data.message);
							setTimeout(() => {
								self.error = '';
							}, 2000);
						}
					});
			}
		},
		removeOneFromCart(item) {
			let self = this;
			let cartItem = {
				id: item.id,
				count: '1',
			};
			if (item.count > 1) {
				cartItem = {
					...cartItem,
					count: item.count - 1,
				};
				this.$http
					.post(process.env.VUE_APP_API + 'cart/add', cartItem)
					.then(() => {
						self.fetchCartItems();
					})
					.catch(() => {});
			} else {
				this.removeFromCart(item);
			}
		},

		removeFromCart(item) {
			let self = this;
			let cartItem = {
				id: item.id,
			};
			this.$http
				.post(process.env.VUE_APP_API + 'cart/remove', cartItem)
				.then(() => {
					self.fetchCartItems();
				})
				.catch(() => {});
		},
		checkIsAuth() {
			this.$http
				.get(process.env.VUE_APP_API + 'is-auth')
				.then((res) => {
					this.isAuth = res.data.authenticated;
					console.log('checkIsAuth', this.isAuth);
					if (res.data.authenticated) {
						this.fetchCartItems();
						//this.getOrderHistory();
						//this.getOfferHistory();
						this.fetchUserData();
					}
				})
				.catch(() => {});
		},
		login(data) {
			this.loaderIsVisible = true;
			this.showResendOption = false;

			this.$http
				.post(process.env.VUE_APP_API + 'login', data)
				.then((res) => {
					this.loaderIsVisible = false;
					if (res.data.status == 'OK') {
						this.isAuth = true;
						this.fetchCartItems();
						this.getOrderHistory();
						this.getOfferHistory();
						this.fetchUserData();
						this.closeLoginModal();
						this.$router.push('/profile/personal-information');
					} else {
						this.error = this.$t(res.data.message);
					}
				})
				.catch((res) => {
					this.loaderIsVisible = false;
					this.error = this.$t(res.response.data.message);
					if (res.response.data.status === 'VERIFY') {
						this.showResendOption = true;
					}
				});
		},
		forgotPass(data) {
			let self = this;
			self.loaderIsVisible = true;
			return this.$http
				.post(process.env.VUE_APP_API + 'user/reset-password', data)
				.then((res) => {
					self.loaderIsVisible = false;
					if (res.data.status == 'OK') {
						self.successMessage = res?.data?.message
							? this.$t(res?.data?.message)
							: 'Success';
						self.error = '';
						setTimeout(() => {
							self.successMessage = '';
						}, 2500);
					} else {
						this.error = this.$t(res.response.data.message);
					}
				})
				.catch((error) => {
					self.loaderIsVisible = false;
					this.error = this.$t(error.response.data.message);
				});
		},
		registration(data) {
			//if (
			//	!/^[a-zA-Z\s-]+$/.test(data.name) ||
			//	!/^[a-zA-Z\s-]+$/.test(data.surname)
			//) {
			//	this.error = this.$t(
			//		'First name and Last name must only contain letters'
			//	);
			//	return;
			//}
			let self = this;
			self.loaderIsVisible = true;
			this.$http
				.post(process.env.VUE_APP_API + 'register', data)
				.then((res) => {
					self.loaderIsVisible = false;
					if (res.data.status == 'OK') {
						self.clearError();
						this.isAuth = true;
						this.fetchCartItems();
						this.getOrderHistory();
						this.getOfferHistory();
						this.fetchUserData();
						this.closeSignupModal();
						this.$router.push('/profile/personal-information');
					} else {
						self.error = this.$t(res.data.message);
						this.isAuth = false;
					}
				})
				.catch((res) => {
					self.loaderIsVisible = false;
					this.error = this.$t(res.response.data.message);
					this.isAuth = false;
				});
		},
		logout() {
			this.$http
				.post(process.env.VUE_APP_API + 'logout')
				.then(() => {
					if (this.$route.name != 'Home') {
						this.$router.push('/');
					}
					this.isAuth = false;
					this.$router.push('/');
				})
				.catch((res) => {
					console.log('Logout error (probably already logged out):', res);
					this.isAuth = false;
					this.clearCart();
					this.$router.push('/');
				});
		},
		getProductPageContent(item) {
			this.productPageItem = '';
			const apiEndpoint = `items/${item.id}`;
			this.$http
				.get(`${process.env.VUE_APP_API}${apiEndpoint}`, {
					params: { currency: this.currencyCode },
				})
				.then((res) => {
					this.productPageItem = res.data.payload;
				})
				.catch((error) => {
					this.error = this.$t('Failed to load product data.');
					console.error(error);
				});
		},
		goToProduct(item) {
			const id = item.id;
			this.$router.push({ name: 'ProductPage', params: { id: id } });
		},
		hideResendOption() {
			this.showResendOption = false;
		},
		getTextPages() {
			this.fetchPages(this.currentLanguage);
		},
		closeMenu() {
			this.menuVisible = false;
			document.body.style.overflowY = 'auto';
		},
		toggleMenu() {
			this.menuVisible = !this.menuVisible;
			//window.scrollTo(0, 0);
			if (this.menuVisible) {
				document.body.style.overflowY = 'hidden';
			} else {
				document.body.style.overflowY = 'auto';
			}
		},
		// menuHeight() {
		//   const doc = document.documentElement;
		//   doc.style.setProperty("--vh", `${window.innerHeight * 0.01}px`);
		// },
		getSettings() {
			this.$http
				.get(process.env.VUE_APP_API + 'settings')
				.then((res) => {
					this.minTopupAmount = res.data.payload.min_top_up;
					this.allPaymentMethods = res.data.payload.payment_methods;
					this.footerRequisites = res.data.payload.requisites;
					this.footerSupportEmail = res.data.payload.support_email;
					this.footerCopyright = res.data.payload.copyright;
					const snippet = res.data.payload.google_tag;
					if (snippet) {
						loadScriptsFromString(snippet);
					}
				})

				.catch(() => {});
		},
		...mapActions('app', ['fetchLanguages']),
	},
	created() {
		// Make constants available in template
		this.TERMS_PAGE = TERMS_PAGE;
		this.PRIVACY_PAGE = PRIVACY_PAGE;
		this.COOKIE_PAGE = COOKIE_PAGE;
	},
	mounted() {
		this.isLoginModalVisibale = false;
		this.isSignupModalVisibale = false;
		this.isProductModalVisibale = false;
		this.isCartModalVisible = false;
		this.sellSkinModalIsVisible = false;
		this.previewSkinModalIsVisible = false;
		this.withdrawModalIsVisible = false;

		this.checkSuccessPaymentOnLoad();

		this.fetchLanguages();
		this.fetchCurrencies();
		this.getTextPages();
		this.getSettings();
		this.checkIsAuth();
		this.hostname = this.getDomainName(window.location.hostname);

		setTimeout(() => {
			this.pageLoaded = true;
		}, 300);
	},
};
</script>
